import styled from "styled-components";
import {
  blackColor,
  disabledColor,
  orangeColor,
  purpleColor,
  whiteColor,
} from "../../../constants/colors";

const PaywallTopBlock = styled.div`
  .paywall-first {
    ul {
      list-style: none;
      padding-left: 20px;
      margin-bottom: 26px;
    }
    ul li::before {
      content: "\\2022";
      color: ${orangeColor};
      font-weight: bold;
      display: inline-block;
      width: 1em;
      margin-left: -1em;
    }
    li {
      color: ${purpleColor};
      text-align: left;
      margin-bottom: 8px;
      font-size: 16px;
      font-weight: 500;
      font-family: SF, sans-serif;
    }
    &-top {
      margin-bottom: 40px;
      background: ${whiteColor};
      backdrop-filter: blur(200px);
      border: 1px solid #aba6d6;
      border-radius: 12px;
      padding: 35px 20px 10px 20px;
    }
    &-dr {
      display: flex;
      padding-top: 12px;
      &-left {
        margin-right: 13px;
      }
      &-right {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        border-bottom: 1px solid #dddcee;
        padding-bottom: 17px;
      }
      &:last-child {
        .paywall-first-dr-right {
          border: none;
        }
      }
    }
    &-center {
      padding-bottom: 18px;
      border-bottom: 1px solid #cac5c2;
      margin-bottom: 20px;
    }
    &-total {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 18px;
      padding-bottom: 18px;
      //border-top: 1px solid #cac5c2;
      border-bottom: 1px solid #cac5c2;
    }
    &-between {
      display: flex;
      justify-content: space-between;
      align-items: center;
      &-text {
        display: flex;
        align-items: center;
        .decor {
          position: relative;
          color: #000;
          text-decoration: none;
          width: 80px;
        }
        .decor:before {
          border-bottom: 2px solid ${blackColor};
        }
      }
      &-banner {
        padding: 5px 5px;
        background: #5db574;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        max-width: 80px;
      }
      &-paid {
        display: flex;
        padding-top: 35px;
        padding-bottom: 9px;
        border-bottom: 1px solid #cac5c2;
        border-top: 1px solid #cac5c2;
      }
    }
    &-rating {
      display: flex;
      flex-direction: column;
      background: ${whiteColor};
      box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
      border-radius: 12px;
      padding: 27px 32px 25px 32px;
      &-top {
        display: flex;
        align-items: center;
        margin-bottom: 41px;
        &-left {
          padding-right: 30px;
          border-right: 1px solid #c6c4df;
        }
        &-right {
          padding-left: 30px;
        }
      }
      &-count {
        display: flex;
      }
      &-bottom {
        display: flex;
        justify-content: space-between;
        &-item {
          &-top {
            width: 100px;
            background: rgba(5, 2, 55, 0.1);
            border-radius: 50px;
            padding-top: 6px;
            padding-bottom: 6px;
            margin-bottom: 6px;
          }
        }
      }
    }
  }
  .paywall-second {
    margin: -53px -20px 20px -20px;
    padding: 74px 20px 45px 20px;
    background: linear-gradient(180deg, #7d7df3 0%, #322c86 121.35%);
    &-slider {
      padding-bottom: 50px;
      &-bullets {
        display: flex;
        justify-content: center;
        margin-top: 15px;
      }
      &-bullet {
        width: 9px;
        height: 9px;
        border-radius: 50%;
        background: ${disabledColor};
        opacity: 0.3;
        margin-left: 8px;
        margin-right: 8px;
        &.active {
          background: #7170e1;
          opacity: 1;
        }
      }
    }
  }
  .paywall-third {
    margin: -53px -20px 20px -20px;
    padding: 53px 20px 45px 20px;
    background: #fffafc;
    //backdrop-filter: blur(200px);
    &-list {
      margin-bottom: 42px;
    }
    &-item {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
    }
  }
  .paywall-info {
    &-sale {
      position: absolute;
      top: -10px;
      right: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 2px 10px;
      background: #648fee;
      border-radius: 8px;
      box-shadow: 0px 2px 12px rgba(100, 143, 238, 0.65);
    }
  }
  .swiper {
    //padding-bottom: 30px;
    &-pagination {
      bottom: 0 !important;
      &-bullet {
        background: #ffffff;
        opacity: 1;
        &-active {
          background: #0885ef;
        }
      }
    }
  }
  .paywall {
    &-bullets {
      width: 100%;
      height: 140px;
      //background: linear-gradient(180deg, rgba(5, 2, 55, 0) 0%, #050237 100.2%);
      display: flex;
      justify-content: center;
      position: relative;
      top: -125px;
      align-items: flex-end;
      z-index: 2;
    }
    &-bullet {
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: rgba(80, 78, 115, 0.3);
      margin-left: 8px;
      margin-right: 8px;
      transition: 0.3s;
      &.active {
        background: ${blackColor};
      }
    }
    &-timeline {
      display: flex;
      //align-items: center;
    }
    &-underlined {
      background: #f3f2ff;
      border-radius: 12px;
      padding: 15px;
      &-title {
        padding-bottom: 12px;
        border-bottom: 1px solid #cecde9;
        margin-bottom: 12px;
      }
    }
  }
  .slide {
    background: #e6ecff;
    border-radius: 12px;
    padding: 27px 20px;
    box-sizing: border-box;
    height: 210px;
  }
  .paywall-comments-new {
    margin-top: 20px;
  }
  .paywall-comment-new {
    background: #f3f2ff;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    padding: 15px 15px 20px 15px;
    margin-bottom: 10px;
    &-text {
      margin-bottom: 17px;
    }
    &-bottom {
      display: flex;
      justify-content: space-between;
    }
    &-avatar {
      display: flex;
    }
    &-stars {
      img {
        width: 109px;
      }
    }
    &-image {
      margin-right: 9px;
      img {
        width: 36px;
        height: 36px;
      }
    }
  }
`;

const PaywallPopupBlock = styled.div`
  position: relative;
  .paywall {
    &-popup {
      padding-top: 20px;
      &-top {
        img {
          position: absolute;
          top: -10px;
          right: -20px;
        }
      }
      &-text {
        display: flex;
        justify-content: space-around;
        align-items: center;
      }
    }
  }
`;

const PaypalPopupBlock = styled.div`
  position: relative;
  .paypal {
    &-popup {
      padding: 40px 3px;
      &-top {
        img {
          position: absolute;
          top: -10px;
          right: -5px;
        }
      }
      &-content {
        img {
          max-width: 124px;
        }
      }
      &-text {
        display: flex;
        justify-content: space-around;
        align-items: center;
      }
    }
  }
`;

export { PaywallTopBlock, PaywallPopupBlock, PaypalPopupBlock };
